import {
    REFRIGERANTS,
    type Refrigerant,
    type RefrigerantCategory,
    type RegulatoryStatus,
} from '../data/refrigerants.js'

export type { Refrigerant, RefrigerantCategory, RegulatoryStatus }

export interface RefrigerantFilter {
    category?:RefrigerantCategory;
    status?:RegulatoryStatus;
}

export function searchRefrigerants (query:string):Refrigerant[] {
    const q = query.trim().toLowerCase()
    if (!q) return [...REFRIGERANTS]
    return REFRIGERANTS.filter(r => {
        const idNorm = r.id.replace(/-/g, '').toLowerCase()
        const qNorm = q.replace(/-/g, '')
        if (idNorm.includes(qNorm)) return true
        if (r.name.toLowerCase().includes(q)) return true
        return r.aliases.some(a => a.toLowerCase().includes(q))
    })
}

export function filterRefrigerants (
    filter:RefrigerantFilter
):Refrigerant[] {
    return REFRIGERANTS.filter(r => {
        if (filter.category && r.category !== filter.category) return false
        if (filter.status && r.status !== filter.status) return false
        return true
    })
}

export function idToSlug (id:string):string {
    return id.toLowerCase()
}

export function gwpBarPercent (gwp:number, maxGwp:number):number {
    if (maxGwp <= 0) return 0
    const pct = (gwp / maxGwp) * 100
    if (pct < 0) return 0
    if (pct > 100) return 100
    return pct
}

export function canCompareCount (count:number):boolean {
    return count >= 2
}

export function findRefrigerantBySlug (
    slug:string
):Refrigerant | undefined {
    const s = slug.toLowerCase()
    return REFRIGERANTS.find(r => r.id.toLowerCase() === s)
}
